import productUv1216 from "../image/products/uv-1216.webp";
import productUv2030 from "../image/products/uv-2030.webp";
import productUv2513 from "../image/products/uv-2513.webp";
import productUv3220 from "../image/products/uv-3220.webp";
import productUv3250 from "../image/products/uv-3250.webp";
import productUv4030 from "../image/products/uv-4030.webp";
import productUv4060 from "../image/products/uv-4060.webp";
import productUv5070 from "../image/products/uv-5070.webp";
import productUv6090 from "../image/products/uv-6090.webp";
import productDtfF20 from "../image/products/dtf/dtf-f20.webp";
import productDtfF30 from "../image/products/dtf/dtf-f30.webp";
import productDtfF30Pro from "../image/products/dtf/dtf-f30pro.webp";
import productDtfF33 from "../image/products/dtf/dtf-f33.webp";
import productDtfF70Pro from "../image/products/dtf/dtf-f70pro.webp";
import productCylinderC360 from "../image/products/cylinder/cylinder-c360.webp";
import productCylinderS360 from "../image/products/cylinder/cylinder-s360.webp";
import productCrystalC33 from "../image/products/crystal/crystal-c33.webp";
import productCrystalC60 from "../image/products/crystal/crystal-c60.webp";
import productCrystalC60Ultra from "../image/products/crystal/crystal-c60-ultra.webp";
import productDtg3250D from "../image/products/dtg/dtg-3250d.webp";
import productDtg3646T from "../image/products/dtg/dtg-3646t.webp";

export { productCategories } from "./productCategories";

export const showcaseProducts = [
  {
    id: "uv-2030",
    category: "uv",
    name: "YY-A23",
    subtitleKey: "productA23Subtitle",
    featureKeys: [
      "productA23Feature1",
      "productA23Feature2",
      "productA23Feature3",
    ],
    image: productUv2030,
  },
  {
    id: "uv-3250",
    category: "uv",
    name: "YY-A35",
    subtitleKey: "productA35Subtitle",
    featureKeys: [
      "productA35Feature1",
      "productA35Feature2",
      "productA35Feature3",
    ],
    image: productUv3250,
  },
  {
    id: "uv-4030",
    category: "uv",
    name: "YY-A43Pro",
    subtitleKey: "productA43Subtitle",
    featureKeys: [
      "productA43Feature1",
      "productA43Feature2",
      "productA43Feature3",
    ],
    image: productUv4030,
  },
  {
    id: "uv-4060",
    category: "uv",
    name: "YY-A46Pro",
    subtitleKey: "productA46Subtitle",
    featureKeys: [
      "productA46Feature1",
      "productA46Feature2",
      "productA46Feature3",
    ],
    image: productUv4060,
  },
  {
    id: "uv-5070",
    category: "uv",
    name: "YY-A57Pro",
    subtitleKey: "productA57Subtitle",
    featureKeys: [
      "productA57Feature1",
      "productA57Feature2",
      "productA57Feature3",
    ],
    image: productUv5070,
  },
  {
    id: "uv-6090",
    category: "uv",
    name: "YY-A69Pro",
    subtitleKey: "productA69Subtitle",
    featureKeys: [
      "productA69Feature1",
      "productA69Feature2",
      "productA69Feature3",
    ],
    image: productUv6090,
  },
  {
    id: "uv-1216",
    category: "uv",
    name: "YY-A1216",
    subtitleKey: "productA1216Subtitle",
    featureKeys: [
      "productA1216Feature1",
      "productA1216Feature2",
      "productA1216Feature3",
    ],
    image: productUv1216,
  },
  {
    id: "uv-2513",
    category: "uv",
    name: "YY-A2513",
    subtitleKey: "productA2513Subtitle",
    featureKeys: [
      "productA2513Feature1",
      "productA2513Feature2",
      "productA2513Feature3",
    ],
    image: productUv2513,
  },
  {
    id: "uv-3220",
    category: "uv",
    name: "YY-A3220",
    subtitleKey: "productA3220Subtitle",
    featureKeys: [
      "productA3220Feature1",
      "productA3220Feature2",
      "productA3220Feature3",
    ],
    image: productUv3220,
  },
  {
    id: "cylinder-c360",
    category: "cylinder",
    name: "YY-C360",
    subtitleKey: "productCylinderElfSubtitle",
    featureKeys: [
      "productCylinderElfFeature1",
      "productCylinderElfFeature2",
      "productCylinderElfFeature3",
    ],
    image: productCylinderC360,
  },
  {
    id: "cylinder-s360",
    category: "cylinder",
    name: "YY-S360",
    subtitleKey: "productCupPlusSubtitle",
    featureKeys: [
      "productCupPlusFeature1",
      "productCupPlusFeature2",
      "productCupPlusFeature3",
    ],
    image: productCylinderS360,
  },
  {
    id: "crystal-c33",
    category: "crystal",
    name: "YY-C33",
    subtitleKey: "productCrystal30Subtitle",
    featureKeys: [
      "productCrystal30Feature1",
      "productCrystal30Feature2",
      "productCrystal30Feature3",
    ],
    image: productCrystalC33,
  },
  {
    id: "crystal-c60",
    category: "crystal",
    name: "YY-C60",
    subtitleKey: "productCrystal60Subtitle",
    featureKeys: [
      "productCrystal60Feature1",
      "productCrystal60Feature2",
      "productCrystal60Feature3",
    ],
    image: productCrystalC60,
  },
  {
    id: "crystal-c60-ultra",
    category: "crystal",
    name: "YY-C60 Ultra",
    subtitleKey: "productCrystal60UltraSubtitle",
    featureKeys: [
      "productCrystalC60UltraFeature1",
      "productCrystalC60UltraFeature2",
      "productCrystalC60UltraFeature3",
    ],
    image: productCrystalC60Ultra,
  },
  {
    id: "dtf-f20",
    category: "dtf",
    name: "YY-F20",
    subtitleKey: "productDtfF20Subtitle",
    featureKeys: [
      "productDtfF20Feature1",
      "productDtfF20Feature2",
      "productDtfF20Feature3",
    ],
    image: productDtfF20,
  },
  {
    id: "dtf-f30",
    category: "dtf",
    name: "YY-F30",
    subtitleKey: "productDtfF30Subtitle",
    featureKeys: [
      "productDtfF30Feature1",
      "productDtfF30Feature2",
      "productDtfF30Feature3",
    ],
    image: productDtfF30,
  },
  {
    id: "dtf-f30pro",
    category: "dtf",
    name: "YY-F30Pro",
    subtitleKey: "productDtfF30ProSubtitle",
    featureKeys: [
      "productDtfF30ProFeature1",
      "productDtfF30ProFeature2",
      "productDtfF30ProFeature3",
    ],
    image: productDtfF30Pro,
  },
  {
    id: "dtf-f33",
    category: "dtf",
    name: "YY-F33",
    subtitleKey: "productDtfF33Subtitle",
    featureKeys: [
      "productDtfF33Feature1",
      "productDtfF33Feature2",
      "productDtfF33Feature3",
    ],
    image: productDtfF33,
  },
  {
    id: "dtf-f70pro",
    category: "dtf",
    name: "YY-F70Pro",
    subtitleKey: "productDtfF70ProSubtitle",
    featureKeys: [
      "productDtfF70ProFeature1",
      "productDtfF70ProFeature2",
      "productDtfF70ProFeature3",
    ],
    image: productDtfF70Pro,
  },
  {
    id: "dtg-3250d",
    category: "dtg",
    name: "YY-3250D",
    subtitleKey: "productDtg3250DSubtitle",
    featureKeys: [
      "productDtg3250DFeature1",
      "productDtg3250DFeature2",
      "productDtg3250DFeature3",
    ],
    image: productDtg3250D,
  },
  {
    id: "dtg-3646t",
    category: "dtg",
    name: "YY-3646T",
    subtitleKey: "productDtg3646TSubtitle",
    featureKeys: [
      "productDtg3646TFeature1",
      "productDtg3646TFeature2",
      "productDtg3646TFeature3",
    ],
    image: productDtg3646T,
  },
];
